import { Box, Chip, Table, TableBody, TableHead, TableRow, Typography } from "@mui/material";
import { ReactNode } from "react";
import { useMoeda } from "../../../../core/hooks/useMoeda";
import { IItemConta } from "../../../interfaces/IItemConta";
import {
    CabecalhoCartao,
    Cartao,
    CelulaCabecalho,
    CelulaCorpo,
    CorpoRolavel,
    EstadoVazio,
    LinhaTabela,
    TituloCartao,
} from "../../../../core/styles/superficies";

interface TabelaResumoProps {
    titulo: string;
    dados: IItemConta[];
    /** Mensagem exibida quando não há nada agrupado. */
    mensagemVazia: string;
    icone: ReactNode;
    altura?: number;
}

/** Ranking de itens/subitens/pagamentos: descrição, quantidade e total. */
export const TabelaResumo = ({ titulo, dados, mensagemVazia, icone, altura = 400 }: TabelaResumoProps) => {
    const { real } = useMoeda();

    return (
        <Cartao sx={{ height: altura }}>
            <CabecalhoCartao>
                <TituloCartao>{titulo}</TituloCartao>
                {!!dados.length && (
                    <Chip
                        size="small"
                        label={dados.length}
                        sx={{ height: 20, fontSize: "0.6875rem", fontWeight: 600 }}
                    />
                )}
            </CabecalhoCartao>

            {dados.length ? (
                <CorpoRolavel>
                    <Table stickyHeader size="small">
                        <TableHead>
                            <TableRow>
                                <CelulaCabecalho>Descrição</CelulaCabecalho>
                                <CelulaCabecalho align="right">Qtd.</CelulaCabecalho>
                                <CelulaCabecalho align="right">Total</CelulaCabecalho>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dados.map((linha, indice) => (
                                <LinhaTabela key={`${titulo}-${linha.descricao}-${indice}`}>
                                    <CelulaCorpo>
                                        <Typography noWrap sx={{ fontSize: "0.8125rem", maxWidth: 200 }}>
                                            {linha.descricao}
                                        </Typography>
                                    </CelulaCorpo>
                                    <CelulaCorpo align="right" sx={{ color: "text.secondary" }}>
                                        {linha.quantidade}
                                    </CelulaCorpo>
                                    <CelulaCorpo align="right" sx={{ fontWeight: 600, whiteSpace: "nowrap" }}>
                                        {real(linha.valorTotal)}
                                    </CelulaCorpo>
                                </LinhaTabela>
                            ))}
                        </TableBody>
                    </Table>
                </CorpoRolavel>
            ) : (
                <EstadoVazio>
                    <Box component="span" sx={{ display: "flex" }}>{icone}</Box>
                    <Typography sx={{ fontSize: "0.8125rem" }}>{mensagemVazia}</Typography>
                </EstadoVazio>
            )}
        </Cartao>
    );
};
